import { List, Map } from "immutable";

import SessionModule from "seneca-common/features/session/models/SessionModule";
import {
  composeSelectorCreator,
  composeSelectors
} from "seneca-common/utils/selectors/compose-selectors";

import { PATH_TO_SESSION_MODULES_STATE } from "../../../consts";
import * as modulesSelectors from "./modules";
import * as moduleSelectors from "./modules/module";

export { modulesSelectors, moduleSelectors };

type State = any;

type SessionModulesState = Map<string, Map<string, SessionModule>>;

export function getSessionModulesSlice(state: State): SessionModulesState {
  return state.get(PATH_TO_SESSION_MODULES_STATE);
}

export function getSessionModules(
  state: modulesSelectors.State,
  sessionId: string
): Map<string, SessionModule> {
  return getSessionModulesSlice(state)!.get(sessionId)!;
}

export const {
  getModule,
  getContentModuleId,
  getContentId,
  getTextToSpeechDisabled,
  getModuleType,
  getContent,
  getTestingActive,
  getTimeStarted,
  getTimeFinished,
  getModuleState,
  getCompleted,
  getSubmitted,
  getGaveUp,
  getUserAnswer,
  getScore,
  wasCorrect,
  wasIncorrect,
  moduleStillInProgress,
  moduleContainsGIF
} = composeSelectors(
  getSessionModules,
  modulesSelectors,
  (sessionId: string, sessionModuleId: string) => [sessionModuleId]
);

export const createScoreSelector = composeSelectorCreator(
  // @ts-ignore
  getSessionModules,
  modulesSelectors.createScoreSelector,
  (sessionId: string, sessionModuleId: string) => [sessionModuleId]
);

export function getNumberOfSessionModules(
  state: State,
  sessionId: string
): number {
  const sessionModules = getSessionModules(state, sessionId);
  return sessionModules ? sessionModules.size : 0;
}

export function sessionModulesExist(state: State, sessionId: string): boolean {
  const sessionModules = getSessionModules(state, sessionId);
  return !!sessionModules;
}

export function getNumberOfCorrectSessionModules(
  state: State,
  sessionId: string
): number {
  const sessionModules = getSessionModules(state, sessionId);

  return sessionModules
    ? // @ts-ignore
      sessionModules.filter(moduleSelectors.wasCorrect).size
    : 0;
}

export const getSessionContentModuleIds = (
  state: any,
  sessionId: string
): List<string> => {
  const sessionModules = getSessionModules(state, sessionId);
  return sessionModules!
    .valueSeq()
    .toList()
    .map(moduleSelectors.getContentModuleId);
};

export const getNumberDistinctModulesWithGif = (
  state: State,
  sessionId: string
): number => {
  const sessionModules = getSessionModules(state, sessionId);
  if (!sessionModules) return 0;
  const modulesWithGIF = sessionModules
    // @ts-ignore
    .valueSeq()
    .toList()
    .reduce((modulesWithGIF: any, module: any) => {
      if (moduleSelectors.moduleContainsGIF(module)) {
        modulesWithGIF.add(moduleSelectors.getContentModuleId(module));
      }

      return modulesWithGIF;
    }, new Set());
  return modulesWithGIF.size;
};
